<div class="toast-container">
  @if (show()) {
    <div class="toast {{ typeClass() }}" role="alert" data-testid="toast">
      <p class="toast-body">{{ message() }}</p>
      <button
        type="button"
        class="toast-close"
        aria-label="Fechar aviso"
        data-testid="toast-close"
        (click)="hideToast()"
      >
        &times;
      </button>
    </div>
  }
</div>
